<template>
  <div>
    <div class="card mb-4">
      <h5 class="card-header">Attachments</h5>
      <div class="card-body">
        <div class="attachments-list">
          <LoadingIndicator v-if="loading" centered />
          <div v-if="!loading">
            <div v-if="attachments.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Filename</th>
                    <th>Size</th>
                    <th>User</th>
                    <th width="200">Created at</th>
                    <th width="100"> Actions</th>
                  </tr>
                </thead>
                <Attachment v-for="item in attachments" :key="'ind' + item.id"
                  :attachment="item"
                  :isSelected="selectedAttachment && selectedAttachment.id === item.id"
                  @click="selectAttachment(item)"
                  @delete="(att) => deleteAttachment(att)"
                  @download="(att) => fetchAttachment(att)"
                />
              </table>
            </div>
            <div v-else class="alert alert-info">No attachments have been added yet.</div>
          </div>
          <h5 class="mt-5 mb-3">Add New Attachment</h5>
          <AttachmentForm ref="attachmentForm" :saving="saving" @submit="saveAttachment" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import Attachment from '@/components/pages/carriers/Attachment.vue';
import AttachmentForm from '@/components/shared/AttachmentForm.vue';

export default {
  name: 'CarrierAttachments',
  props: {
    carrier: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LoadingIndicator,
    Attachment,
    AttachmentForm,
  },
  data() {
    return {
      attachments: [],
      selectedAttachment: null,
      loading: false,
      saving: false,
      deleting: false,
    };
  },
  methods: {
    selectAttachment(attachment) {
      if (this.selectedAttachment && this.selectedAttachment.id === attachment.id) {
        this.selectedAttachment = null;
      } else {
        this.selectedAttachment = attachment;
      }
    },
    async saveAttachment({ name, file }) {
      this.saving = true;

      const data = new FormData();
      data.append('file', file, file.name);
      if (name) data.append('name', name);

      const response = await ApiClient.carriers.attachments.post({
        carrierId: this.carrier.id,
        body: data,
      });
      this.saving = false;
      if (response.status === 200) {
        this.attachments.push(response.data.data);
        this.$refs.attachmentForm.reset();
      }
    },
    async deleteAttachment(attachment) {
      this.deleting = true;
      await ApiClient.carriers.attachments.delete({
        carrierId: this.carrier.id,
        id: attachment.id,
      });
      this.deleting = false;
      this.attachments = this.attachments.filter(x => x.id != attachment.id);
    },
    async fetchAttachment(attachment) {
      let response = await ApiClient.carriers.attachments.get({
        carrierId: this.carrier.id,
        id: attachment.id,
        blobRespone: true,
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', attachment.filename);
      link.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
    },
    async showAttachment(attachment) {
      const link = document.createElement('a');
      link.href = attachment.publicUrl;
      link.setAttribute('target', '_blank');
      link.click();
    },
  },
  watch: {
    carrier: {
      immediate: true,
      async handler(carrier) {
        this.loading = true;
        const response = await ApiClient.carriers.attachments.get({ carrierId: carrier.id });
        this.loading = false;
        this.attachments = response.data.data;
      },
    },
  },
};
</script>

